// Presentational discriminator for reports that carry a report_category.
// Existing (legacy) reports omit report_category and must render unbadged.
export function reportCategoryLabel(category?: string): string | null {
  switch (category) {
    case 'lactate_threshold':
      return 'Lactate';
    default:
      return null;
  }
}
